import React from 'react'
import { Spin } from 'antd'

export const Loader = ({
  loading,
  minHeight,
  children,
  pageLevel,
  spinClassName = '',
  ...props
}) => {
  if (pageLevel) {
    return (
      <>
        {children}
        {loading && (
          <div style={{
            position: 'fixed',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            pointerEvents: 'none',
            background: 'rgba(255,255,255,0.5)',
          }}>
            <Spin size="large" />
          </div>
        )}
      </>
    )
  }

  if (children) {
    return (
      <>
        {children}
        {loading && (
          <div style={{
            position: 'fixed',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            pointerEvents: 'none',
            background: 'rgba(255,255,255,0.5)',
          }}>
            <Spin size="large" />
          </div>
        )}
      </>
    )
  }

  return (
    <div className={spinClassName}>
      <Spin spinning={loading} size="large">
        <div style={{ minHeight: minHeight || '60vh' }}></div>
      </Spin>
    </div>
  )
}
